/* eslint-disable react/no-danger */
import type { FunctionComponent } from 'react';
import React from 'react';
import classNames from 'classnames';

import { PowerUpTestIds } from '@trello/test-ids';

import { PowerUpItemType } from 'app/src/components/PowerUp';
import {
  useWorkspaceNavigation,
  useWorkspaceNavigationHidden,
} from 'app/src/components/WorkspaceNavigation';
import { PowerUpItem } from './PowerUpItem';
import type { Plugins } from './types';

import styles from './PowerUpsList.less';

interface PowerUpsListProps {
  title?: string;
  plugins: Plugins;
  type?: PowerUpItemType;
  testId?: PowerUpTestIds;
}

export const PowerUpsList: FunctionComponent<PowerUpsListProps> = ({
  title,
  plugins,
  type = PowerUpItemType.Description,
}) => {
  const [{ expanded: _workspaceNavigationExpanded }] = useWorkspaceNavigation();
  const [
    { hidden: _workspaceNavigationHidden },
  ] = useWorkspaceNavigationHidden();
  const workspaceNavigationExpanded =
    !_workspaceNavigationHidden && _workspaceNavigationExpanded;

  const powerUpItems = plugins.map((plugin) => {
    return <PowerUpItem key={plugin.id} type={type} plugin={plugin} />;
  });

  return (
    <div className={styles.directoryPowerUpsList}>
      <div
        className={classNames(styles.directoryPowerUpsListHeader, {
          [styles.workspaceNavigationExpanded]: workspaceNavigationExpanded,
        })}
      >
        {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
      </div>
      <div
        className={classNames(styles.flexRowWrap, styles.powerUpsList, {
          [styles.workspaceNavigationExpanded]: workspaceNavigationExpanded,
        })}
        data-testid={PowerUpTestIds.PowerUpsList}
      >
        {powerUpItems}
      </div>
    </div>
  );
};
